import { useTenantContext } from '../tenant-context/index.tsx';

type CloudId = string;

export const useCloudId = (): CloudId => {
	const tenantContext = useTenantContext();
	return tenantContext && tenantContext.cloudId;
};
